import React, {PureComponent} from 'react';
import DokumentList from './DokumentList';

export default class DokumentListField extends PureComponent {

    handleAdd = dokument => {
        const {value, onChange} = this.props;
        onChange([...value, dokument]);
    };

    handleDelete = dokument => {
        const {value, onChange} = this.props;
        onChange(value.filter(item => item !== dokument));
    };

    render() {
        const {value} = this.props;
        return <DokumentList dokumentList={value}
                             onAdd={this.handleAdd}
                             onDelete={this.handleDelete}/>;
    }
}
